/**
 * URLs pour le dev local : définir VITE_NETLIFY_FUNCTIONS_ORIGIN (ex. http://127.0.0.1:8888)
 * si les fonctions ne sont pas servies sur le même origine que Vite, ou laisser vide et utiliser
 * le proxy défini dans vite.config.js (/.netlify/functions → Netlify dev).
 */
export function netlifyFunctionUrl(name) {
    const origin = (import.meta.env.VITE_NETLIFY_FUNCTIONS_ORIGIN || '').replace(/\/$/, '');
    const path = `/.netlify/functions/${name}`;
    return origin ? `${origin}${path}` : path;
}

/** Préfixe import.meta.env.BASE_URL pour les fichiers du dossier public (déploiement sous sous-chemin). */
export function publicUrl(path) {
    const base = import.meta.env.BASE_URL;
    const clean = path.startsWith('/') ? path.slice(1) : path;
    return `${base}${clean}`;
}
